import { render, staticRenderFns } from "./editSinglePage.vue?vue&type=template&id=44e20250&scoped=true&"
import script from "./editSinglePage.vue?vue&type=script&lang=ts&"
export * from "./editSinglePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e20250",
  null
  
)

export default component.exports